@if (isLoading()) {
  <dojo-loader class="flex h-full items-center justify-center" />
} @else if (loadError()) {
  <div class="flex h-full flex-col items-center justify-center gap-4 p-4">
    <div class="text-neutral-500">{{ 'no_graded_attempt_found' | transloco }}</div>
    <dojo-button fill="outline" (click)="closeDialog()">
      {{ 'close' | transloco }}
    </dojo-button>
  </div>
} @else {
  <dojo-question
    [showAttemptSelector]="true"
    [footerTemplateRef]="customFooter"
    (completed)="onQuestionCompleted($event)"
  />
}

<ng-template #customFooter>
  <!-- Mobile footer -->
  <dojo-footer-panel *ifSmallLayout [limitWidthContainer]="false">
    <div right class="right item-center flex flex-row justify-end gap-2">
      <dojo-button
        fill="outline"
        (click)="navigateToTryAgain()"
        [ngClass]="state.isQuestionMultipleChoice ? 'small:w-auto mr-[96px] block w-full' : 'w-full md:min-w-[178px]'"
      >
        {{ 'questions.try_again' | transloco }}
      </dojo-button>
    </div>
  </dojo-footer-panel>

  <!-- Desktop footer -->
  <dojo-footer-panel *ifWideLayout [limitWidthContainer]="false">
    <div left>
      <dojo-button fill="outline" (click)="closeDialog()" class="w-full md:min-w-[204px]">
        {{ 'question_bank.back_to_bank' | transloco }}
      </dojo-button>
    </div>

    <div right class="flex flex-row justify-end gap-2">
      <dojo-button fill="outline" (click)="navigateToTryAgain()" class="w-full md:min-w-[204px]">
        {{ 'questions.try_again' | transloco }}
      </dojo-button>
    </div>
  </dojo-footer-panel>
</ng-template>
